import {css} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import runModal from 'ui-library/runModal';

import {
  automationFileConfigStyles,
  AutomationOutputFileConfigEditorProps,
  SectionNumber,
} from '../AutomationFileConfigUtils';
import {ClientAutomationOutputFileConfigSpec} from '../RunSchemaSpecConstants';
import {convertColumnTypeMetadatasToString} from './DatasetConfigConstants';
import DatasetConfigModal, {DatasetConfigChanges} from './DatasetConfigModal';
import SetColumnsMapEditor from './SetColumnsMapEditor';

interface AutomationOutputFileConfigEditorDatasetMapperProps {
  outputFileConfig: ClientAutomationOutputFileConfigSpec;
  onUpdateConfig: (newConfig: ClientAutomationOutputFileConfigSpec) => void;
}

function AutomationOutputFileConfigEditorDatasetMapper(
  props: AutomationOutputFileConfigEditorDatasetMapperProps
): JSX.Element {
  return (
    <>
      <div
        className={css(
          automationFileConfigStyles.description,
          automationFileConfigStyles.sectionDescription,
          automationFileConfigStyles.sectionDescriptionAbove
        )}
      >
        Select columns for your dataset and optionally enable automatic column mapping to an analysis template
      </div>
      <a
        onClick={() => {
          runModal(DatasetConfigModal, {
            outputFileConfig: props.outputFileConfig,
            onRequestClose: () => {},
            onRequestSubmit: (configChanges: DatasetConfigChanges) => {
              props.onUpdateConfig({
                ...props.outputFileConfig,
                analysisTemplate: configChanges.analysisTemplate,
                datasetConfigJson: convertColumnTypeMetadatasToString(configChanges.columnTypeMetadatas),
              });
            },
          });
        }}
      >
        Configure dataset
      </a>
    </>
  );
}

export default function AutomationOutputFileConfigEditorColumnsMapSection(
  props: AutomationOutputFileConfigEditorProps
): JSX.Element {
  return (
    <div className={css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder)}>
      <SectionNumber sectionNumber={4} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure column mapping</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        Tell Benchling how to interpret the columns in your output file.
      </div>
      <SetColumnsMapEditor {...props} shouldShowUploadedFilesOnly={true} />
      {BenchlingConfig.LAB_AUTOMATION_ANALYSIS_INTEGRATION && (
        <AutomationOutputFileConfigEditorDatasetMapper
          outputFileConfig={props.outputFileConfig}
          onUpdateConfig={props.onUpdateConfig}
        />
      )}
    </div>
  );
}
